import React from "react";
import Trainers from "../../components/trainers/Trainers";
import HelmetWrapper from "../../HelmetWrapper";

const TrainerPage = () => {
  return (
    <HelmetWrapper title="WTF: Trainers">
      <Trainers />
    </HelmetWrapper>
  );
};

export default TrainerPage;
